import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			height: 60,
			borderBottom: `1px solid ${theme.palette.grey[200]}`,
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			position: 'absolute',
			top: 0,
			width: '100%',
			[theme.breakpoints.down('sm')]: {
				padding: `0px ${theme.spacing(1)}px`,
			},
		},
		closeButton: {
			width: 24,
			height: 24,
			padding: 0,
		},
		leftMenu: {
			alignSelf: 'stretch',
			flexDirection: 'row',
			alignItems: 'center',
			display: 'flex',
			paddingLeft: theme.spacing(2),
		},
		middleMenu: {
			flex: 1,
			alignSelf: 'stretch',
			flexDirection: 'row',
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'center',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'space-around',
			},
		},
		rightMenu: {
			alignSelf: 'stretch',
			flexDirection: 'row',
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'flex-end',
		},
		menuItem: {
			cursor: 'pointer',
			alignSelf: 'stretch',
			display: 'flex',
			alignItems: 'center',
			borderBottomWidth: 3,
			borderBottomStyle: 'solid',
			borderBottomColor: 'transparent',
			[theme.breakpoints.up('md')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2),
			},
		},
		menuActive: {
			borderBottomColor: theme.palette.primary.main,
		},
		postAs: {
			height: theme.spacing(6),
		},
		avatar: {
			width: 38,
			height: 38,
			minWidth: 38,
		},
		info: {
			paddingTop: 0,
			paddingBottom: 0,
		},
		avatarContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'row',
			// marginRight: theme.spacing(2),
			'& > svg': {
				fill: theme.palette.grey[500],
			},
		},
		sidebarDrawer: {
			width: 250,
		},
		avatarSidebarContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column',
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
			'& div:first-child': {
				width: theme.spacing(10),
				height: theme.spacing(10),
			},
			'& div:last-child': {
				marginTop: theme.spacing(1),
				color: theme.palette.grey[800],
				fontWeight: 300,
			},
		},
		sidebarContentContainer: {
			padding: theme.spacing(2),
		},
		sidebarHeader: {
			fontSize: 16,
			color: theme.palette.grey[500],
			// [theme.breakpoints.down('sm')]: {
			// 	fontSize: 24,
			// },
			'&:hover': {
				cursor: 'pointer',
			},
		},
		sidebarRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			alignItems: 'center',
			'&:hover': {
				cursor: 'pointer',
			},
			'& div:not(:first-child)': {
				color: theme.palette.grey[800],
				marginLeft: theme.spacing(1),
			},
		},
		popper: {
			zIndex: 1,
			marginTop: 15,
			minWidth: 250,
			'& > div': {
				borderRadius: 8,
			},
			'& $arrow': {
				top: 0,
				left: 'auto',
				right: theme.spacing(1.5),
				marginTop: '-0.9em',
				width: '3em',
				height: '1em',
				'&::before': {
					borderWidth: '0 1em 1em 1em',
					borderColor: `transparent transparent ${theme.palette.common.white} transparent`,
				},
			},
		},
		arrow: {
			position: 'absolute',
			fontSize: 7,
			width: '3em',
			height: '3em',
			'&::before': {
				content: '""',
				margin: 'auto',
				display: 'block',
				width: 0,
				height: 0,
				borderStyle: 'solid',
			},
		},
	})
